import {
  IMarketCampaignBasicInfo,
  IMarketCampaignChannel,
  IMarketCampaignDraftStep,
} from "../redux/marketCampaign/marketCampaign.types";

export const mockCampaignContext = {
  marketCampaign: {} as IMarketCampaignBasicInfo,
  state: {
    marketCampaign: {} as IMarketCampaignBasicInfo,
    draftSteps: {} as IMarketCampaignDraftStep,
    campaignChannel: {} as IMarketCampaignChannel,
    completionSteps: {
      step1: false,
      step2: false,
      step3: false,
      step4: false,
    },
    activeStep: 0,
    maxAllowedSteps: 0,
  },
  draftSteps: {} as IMarketCampaignDraftStep,
  campaignChannel: {} as IMarketCampaignChannel,
  completionSteps: {
    step1: false,
    step2: false,
    step3: false,
    step4: false,
  },
  activeStep: 0,
  maxAllowedSteps: 0,
  isEditable: true,
  isCompleted: false,
  isAutoGenerating: false,
  isReadyToExecution: false,
  isAutoGenerationFailed: false,
  onKeyChange: () => {},
  onStateChange: () => {},
};
